<template>
  <div>
    <div :id="id" class="linechart-style" ref="linechart"></div>
  </div>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: 'rgba(88,198,228, 1)'
    },
    id: {
      type: String,
      default: '',
      require: true
    }
  },
  data() {
    return {
      linechart: {}
    }
  },
  mounted() {
    // window.addEventListener('resize', () => {
    //   this.linechart.dispose()
    //   setTimeout(() => {
    //     this.chartInit()
    //   }, 10)
    // })
  },
  methods: {
    chartInit(PaymentData, SettlementData, DeliveryData) {
      this.linechart = this.$echarts.init(document.getElementById(this.id))
      this.linechart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          extraCssText: 'background:#fff',
          formatter: function (params) {
            let str = params[0].name + '<br/>'
            for (const item of params) {
              str += "<div class='extra-text-css'><div class='circular-ring' style='border: 2px solid " + item.color + ";'></div><div style='color:" + item.color + ";margin:0 8px'>" + item.seriesName + '</div><div style="width:40px;text-align:right">' + item.value + '</div></div>'
            }
            return str
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [
            '1月',
            '2月',
            '3月',
            '4月',
            '5月',
            '6月',
            '7月',
            '8月',
            '9月',
            '10月',
            '11月',
            '12月'
          ],
          axisLine: {
            show: false
          },
          axisTick: {
            show: true,
            inside: true,
            alignWithLabel: true
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              width: 1,
              type: 'dashed'
            }
          }
        },
        series: [
          {
            type: 'line',
            name: '月均付款周期天数',
            smooth: 0.4,
            lineStyle: {
              color: 'rgba(42,119,236,1)'
            },
            itemStyle: {
              color: 'rgba(42,119,236,1)'
            },
            data: PaymentData
          },
          {
            type: 'line',
            smooth: 0.45,
            name: '月均结算周期天数',
            lineStyle: {
              color: 'rgba(0,206,133,1)'
            },
            itemStyle: {
              color: 'rgba(0,206,133,1)'
            },
            data: SettlementData
          },
          {
            type: 'line',
            smooth: 0.4,
            name: '月均交付周期天数',
            lineStyle: {
              color: 'rgba(230,108,104,1)'
            },
            itemStyle: {
              color: 'rgba(230,108,104,1)'
            },
            data: DeliveryData
          }
        ],
        grid: {
          left: '4%',
          top: '10%',
          right: '4%',
          bottom: '10%'
        }
      })
    }
  }
}
</script>
<style lang="less">
.linechart-style {
  width: 100%;
  height: 256px;
  .extra-text-css {
    background: #F6F6F8 !important;
    border-radius: 7px;
    padding:4px 6px;
    margin-top:8px;
    font-size: 12px;
    font-weight: 500;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .circular-ring {
      width: 10px;
      height: 10px;
      background-color: #ffffff;
      border-radius: 50%;
      margin-bottom: 7px;
    }
  }
}
</style>
